import { useState, useEffect } from 'react';
import { fetchContent } from '../../services/parameter.service';

const useContentLaboratorio = () => {
  const [contentLaboratorio, setContentLaboratorio] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getContentLaboratorio = async () => {
    setIsLoading(true);

    try {
      const responseContent = await fetchContent('laboratorios');
      setContentLaboratorio(responseContent.data.list);

      setIsLoading(false);
    } catch (error) {
      console.error(' ERROR EN useContentLaboratorio --> ', error);
    }
  };

  useEffect(() => {
    getContentLaboratorio();
  }, []);

  return {
    contentLaboratorio,
  };
};

export default useContentLaboratorio;
